import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=cab6560c&"
import script from "./UserEdit.js?vue&type=script&lang=js&"
export * from "./UserEdit.js?vue&type=script&lang=js&"
import style0 from "./UserEdit.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports